export const FcCarSales = (id: string): string => ({ "3": "4", "4": "3" }[id] || id)